import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";

interface PremiumSuccessProps {
  productName: string;
  productImage?: string;
  show: boolean;
}

export default function PremiumSuccess({ productName, productImage, show }: PremiumSuccessProps) {
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!show) return null;

  return (
    <>
      {/* Confetti Effect */}
      <Confetti
        width={windowSize.width}
        height={windowSize.height}
        recycle={false}
        numberOfPieces={500}
        gravity={0.3}
      />

      {/* Success Modal */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0, 0, 0, 0.85)",
          backdropFilter: "blur(8px)",
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
        }}
      >
        <div
          style={{
            background: "var(--bg, #0a0a0a)",
            border: "2px solid var(--primary, #FFD700)",
            borderRadius: 16,
            padding: 40,
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
            boxShadow: "0 30px 80px rgba(255, 215, 0, 0.3)",
          }}
        >
          {/* Success Icon */}
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              fontSize: 40,
            }}
          >
            ✓
          </div>

          {/* Title */}
          <h2
            style={{
              margin: 0,
              marginBottom: 16,
              fontSize: 28,
              fontWeight: 700,
              color: "var(--primary, #FFD700)",
            }}
          >
            Satın Alma Başarılı!
          </h2>

          {/* Product Image */}
          {productImage && (
            <div style={{ marginBottom: 20 }}>
              <img
                src={productImage}
                alt={productName}
                style={{
                  width: "100%",
                  maxWidth: 200,
                  height: "auto",
                  borderRadius: 8,
                  border: "2px solid var(--primary, #FFD700)",
                }}
              />
            </div>
          )}

          {/* Product Name */}
          <p
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "var(--text, #fff)",
              marginBottom: 8,
            }}
          >
            {productName}
          </p>

          {/* Description */}
          <p
            style={{
              fontSize: 14,
              color: "var(--muted-text, #aaa)",
              marginBottom: 32,
            }}
          >
            Premium içeriğiniz hesabınıza eklendi. Artık profilinizde kullanabilirsiniz!
          </p>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
            <button
              onClick={() => navigate("/premium-shop")}
              style={{
                padding: "12px 24px",
                borderRadius: 8,
                border: "1px solid var(--muted, #333)",
                background: "transparent",
                color: "var(--text, #fff)",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 500,
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255, 215, 0, 0.1)";
                e.currentTarget.style.borderColor = "var(--primary, #FFD700)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.borderColor = "var(--muted, #333)";
              }}
            >
              Alışverişe Devam Et
            </button>
            <button
              onClick={() => navigate("/profile")}
              style={{
                padding: "12px 24px",
                borderRadius: 8,
                border: "none",
                background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
                color: "#000",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 600,
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              Profilime Git
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
